import type { ComponentType } from 'react';

import { cn } from '../lib/cn';
import type { TIconProps } from './icons';

export type TDiscTone = 'success' | 'failure' | 'motion' | 'suppressed';

const DISC: Record<TDiscTone, string> = {
  success: 'bg-success',
  failure: 'bg-danger',
  motion: 'bg-motion',
  suppressed: 'bg-faint',
};

/** A status said with a filled disc and a glyph cut out of it: runs, clients, requests. */
export const StatusDisc = ({
  tone,
  icon: Glyph,
}: {
  tone: TDiscTone;
  icon: ComponentType<TIconProps>;
}) => (
  <span
    aria-hidden
    className={cn(
      'flex size-status-glyph shrink-0 items-center justify-center rounded-full text-surface-sunken',
      DISC[tone],
    )}
  >
    <Glyph size={9} />
  </span>
);
